(() => {
  'use strict';
  const form = document.getElementById('quote-form-page');
  if (!form || form.dataset.websiteIntakeBound) return;
  form.dataset.websiteIntakeBound = 'true';
  const endpoint = 'https://tools.rftransparent.ca/api/website-sales/intake';
  const key = 'grs-quote-intake-v1';
  const lifetime = 30 * 60 * 1000;
  const clear = () => { try { sessionStorage.removeItem(key); } catch {} };
  const read = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!saved || typeof saved.createdAt !== 'number' || Date.now() - saved.createdAt > lifetime || saved.createdAt > Date.now() + 60000) { clear(); return null; }
      return saved;
    } catch { clear(); return null; }
  };
  // Preserve native validation, CAPTCHA and Shopify's contact submission.
  // The saved details are forwarded only on Shopify's successful response page.
  form.addEventListener('submit', () => {
    const data = new FormData(form);
    const value = (name, max = 300) => String(data.get('contact[' + name + ']') || '').trim().slice(0, max);
    const project = {};
    ['project_type', 'project_zip', 'project_layout', 'surface', 'height', 'finish', 'project_timing', 'installation_needed'].forEach(name => { project[name] = value(name); });
    project.project_state = value('state', 50);
    project.total_length = value('total_length', 30);
    project.selected_product = value('selected_product');
    project.selected_variant_label = value('selected_variant');
    const variant = value('selected_variant_id', 20);
    if (/^\d{1,20}$/.test(variant)) project.selected_variant = variant;
    const path = value('selected_product_url', 250).match(/^\/products\/([a-z0-9][a-z0-9-]{0,199})$/);
    if (path) project.selected_product_handle = path[1];
    const count = Number(value('selected_quantity', 6));
    project.quantity = Number.isInteger(count) && count >= 1 && count <= 100000 ? count : 1;
    const payload = {requestId: crypto.randomUUID(), name: value('name', 150), email: value('email', 254), phone: value('phone', 50), message: value('body', 10000), project};
    try { sessionStorage.setItem(key, JSON.stringify({createdAt: Date.now(), payload})); } catch {}
  });
  if (!form.querySelector('[data-quote-received]')) { read(); return; }
  const saved = read();
  if (!saved?.payload) return;
  let attempts = 0;
  async function forward() {
    attempts += 1;
    try {
      const response = await fetch(endpoint, {method: 'POST', mode: 'cors', credentials: 'omit', redirect: 'error', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(saved.payload), signal: AbortSignal.timeout(15000)});
      if (response.status === 202 || (response.status >= 400 && response.status < 500 && response.status !== 429)) { clear(); return; }
    } catch {}
    if (attempts < 3 && Date.now() - saved.createdAt < lifetime) setTimeout(forward, attempts * 2000);
  }
  forward();
})();
